import {Log} from '../../log';
import React, {ErrorInfo, PropsWithChildren, useEffect} from 'react';

interface ErrorDetails {
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

interface ErrorContainerProps extends ErrorDetails {
  ErrorComponent: React.ComponentType<React.PropsWithChildren>;
}

export class ErrorBoundary extends React.Component<
  {
    ErrorComponent: React.ComponentType<{children?: React.ReactNode}>;
    children?: React.ReactNode;
  },
  ErrorDetails
> {
  state: ErrorDetails = {
    error: null,
    errorInfo: null,
  };

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({error, errorInfo});
  }

  render() {
    return <ErrorContainer {...this.props} {...this.state} />;
  }
}

function ErrorContainer({
  error,
  errorInfo,
  children,
  ErrorComponent,
}: PropsWithChildren<ErrorContainerProps>) {
  useEffect(() => {
    if (error) {
      Log.error(
        '@aboutyou/mlm',
        `Global Error Boundary rendered Oops component`,
        {
          error,
          stackTrace: errorInfo?.componentStack.substring(0, 150),
        },
      );
    }
  }, [error, errorInfo]);

  if (!error) {
    return children as JSX.Element;
  }

  return <ErrorComponent />;
}
